import { z } from 'zod';
import { zStepUp } from './auth.js';
import { zAddress, zU64String } from './primitives.js';
/** Wrapped SOL mint; swap quotes use it for native SOL (wrapped and unwrapped automatically). */
export const WRAPPED_SOL_MINT = 'So11111111111111111111111111111111111111112';
export const zWalletLabel = z
    .string()
    .trim()
    .min(1, 'Give the wallet a name')
    .max(40, 'Keep the name under 40 characters');
export const zCreateWallet = z.object({ label: zWalletLabel.optional() });
export const zImportWallet = z.object({
    label: zWalletLabel.optional(),
    /** Base58 private key (as exported by Phantom/Solflare) or a JSON byte array. */
    secretKey: z.string().trim().min(40, 'Paste the full private key').max(1_000),
});
export const zRenameWallet = z.object({ label: zWalletLabel });
export const zSendInput = z.object({
    to: zAddress,
    /** Token mint; omit for SOL. */
    mint: zAddress.optional(),
    /** Exact amount in base units (lamports for SOL). */
    amount: zU64String.refine((value) => BigInt(value) > 0n, { message: 'Enter an amount greater than zero' }),
    stepUp: zStepUp.optional(),
});
export const zExportKeyInput = z.object({ stepUp: zStepUp.optional() });
// ── Swap ─────────────────────────────────────────────────────────────────────────────────────
export const zSwapQuoteQuery = z.object({
    inputMint: zAddress,
    outputMint: zAddress,
    /** Exact input amount in base units. */
    amount: zU64String.refine((value) => BigInt(value) > 0n, { message: 'Enter an amount greater than zero' }),
    /** Optional slippage cap in basis points (Jupiter picks one when omitted). */
    slippageBps: z.coerce.number().int().min(1).max(5_000).optional(),
});
export const zSwapExecute = z.object({ requestId: z.string().min(8).max(100) });
export const zTokenSearchQuery = z.object({ q: z.string().trim().min(1).max(64) });
//# sourceMappingURL=wallets.js.map